import { setLocale, SUPPORTED_LOCALES } from '@/i18n';
import { localizedPath } from '@/seoConfig';

export default {
  name: 'LanguageSwitcher',
  props: { footer: Boolean },
  computed: {
    currentLocale() { return this.$i18n.locale; },
    availableLocales() { return SUPPORTED_LOCALES; },
  },
  methods: {
    async selectLocale(locale) {
      try {
        await setLocale(locale);
        const currentPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;
        const target = localizedPath(currentPath, locale);
        if (target !== currentPath) window.location.assign(target);
      } catch (error) {
        console.error('[LanguageSwitcher] Failed to load language', error);
        this.$toast?.add?.({ severity: 'error', summary: this.$t('errors.network'), life: 4000 });
      }
    },
  },
};
